import React, { useEffect, useState } from 'react';
import OffersList from '../../../../../components/OffersList';
import ModernOffersList from '../../../../../components/ModernOffersList';
import AccountPage from '../../../../../components/consultant/AccountPage';
import FavoritesPage from '../../../../../components/consultant/FavoritesPage';
import SearchesPage from '../../../../../components/consultant/SearchesPage';
import MessagesPage from '../../../../../components/consultant/MessagesPage';
import ResumesPage from '../../../../../pages/ResumesPage';
import ImpersonationExitButton from '../../../../../components/ImpersonationExitButton';
import './ModernSidebar.css';

const ConsultantDashboard = ({ activeTab: externalActiveTab, setActiveTab: externalSetActiveTab }) => {
    const [internalActiveTab, setInternalActiveTab] = useState('browse-offers');
    
    // Use external activeTab if provided, otherwise use internal state
    const currentActiveTab = externalActiveTab || internalActiveTab;
    const setCurrentActiveTab = externalSetActiveTab || setInternalActiveTab;
    const [profile, setProfile] = useState({
        civility: '',
        name: '',
        username: '',
        email: '',
        phone: '',
        photo_url: ''
    });
    const [loadingProfile, setLoadingProfile] = useState(false);
    const [profileError, setProfileError] = useState('');

    const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000/api';

    // Helper to get auth payload (user + token) from storage
    const getAuthPayload = () => {
        const storages = [window.localStorage, window.sessionStorage];
        const keys = ['authData','auth','userData','senoffre_auth','loginData','currentUser','user'];
        for (const storage of storages) {
            for (const key of keys) {
                try {
                    const raw = storage.getItem(key);
                    if (!raw) continue;
                    const data = JSON.parse(raw);
                    // Structures possibles: { token, tokenType, email, user: { id, ... } }
                    if (data?.user?.id) return { user: data.user, token: data.token || data.idToken || data.access_token, tokenType: data.tokenType || 'Bearer' };
                    if (data?.id) return { user: data, token: data.token || data.access_token, tokenType: data.tokenType || 'Bearer' }; // fallback if root contains user
                } catch (_) { /* ignore */ }
            }
            // Fallback: scan all keys
            try {
                for (let i = 0; i < storage.length; i++) {
                    const k = storage.key(i);
                    if (!k) continue;
                    const raw = storage.getItem(k);
                    if (!raw) continue;
                    try {
                        const data = JSON.parse(raw);
                        if (data?.user?.id) return { user: data.user, token: data.token || data.access_token, tokenType: data.tokenType || 'Bearer' };
                        if (data?.id) return { user: data, token: data.token || data.access_token, tokenType: data.tokenType || 'Bearer' };
                    } catch (_) {}
                }
            } catch (_) {}
        }
        return null;
    };

    useEffect(() => {
        const auth = getAuthPayload();
        const user = auth?.user;
        if (!user?.id) return;
        const controller = new AbortController();
        const load = async () => {
            setLoadingProfile(true);
            setProfileError('');
            try {
                const res = await fetch(`${API_BASE}/users/${user.id}`, {
                    headers: {
                        'Accept': 'application/json',
                        ...(auth?.token ? { 'Authorization': `${auth.tokenType || 'Bearer'} ${auth.token}` } : {})
                    },
                    signal: controller.signal
                });
                if (!res.ok) {
                    throw new Error(`Erreur ${res.status}`);
                }
                const data = await res.json();
                // Support both {data: {...}} and direct object
                const u = data?.data || data || {};
                setProfile({
                    civility: '',
                    name: u.name || '',
                    username: u.username || '',
                    email: u.email || '',
                    phone: u.phone || u.phone_national || '',
                    photo_url: u.photo_url || u.photo || ''
                });
            } catch (e) {
                setProfileError("Impossible de charger le profil.");
            } finally {
                setLoadingProfile(false);
            }
        };
        load();
        return () => controller.abort();
    }, []);

    const stats = [
        { title: "Candidatures", value: "12", icon: "fa-paper-plane", color: "primary", trend: "+3 ce mois" },
        { title: "Favoris", value: "8", icon: "fa-heart", color: "success", trend: "+2 cette semaine" },
        { title: "Recherches", value: "15", icon: "fa-search", color: "warning", trend: "+5 aujourd'hui" },
        { title: "Messages", value: "12", icon: "fa-envelope", color: "info", trend: "+3 non lus" }
    ];

    return (
        <div style={{ width: '100%' }}>
            {/* Bouton de sortie d'emprunt d'identité */}
            <ImpersonationExitButton style={{ position: 'absolute', top: '1rem', right: '1rem', zIndex: 1000 }} />
            
            {/* Main Content Only */}
            {currentActiveTab === 'profile' && <AccountPage />}
            {currentActiveTab === 'favorites' && <FavoritesPage />}
            {currentActiveTab === 'searches' && <SearchesPage />}
            {currentActiveTab === 'messages' && <MessagesPage />}
            {currentActiveTab === 'cvs' && <ResumesPage />}
            {currentActiveTab === 'browse-offers' && (
                <ModernOffersList detailRouteBase="/consultant/job-detail" />
            )}
        </div>
    );
};

export default ConsultantDashboard;
